<!-- Step 3/3 — the account form. Dark header, scrolling form, fixed footer;
     the submit stays reachable while the keyboard is open. -->
<main class="onb onb--sheet">

  <header class="onb__head">
    <div class="onb__topbar onb__topbar--split">
      <button class="onb__circle onb__circle--onbrand" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
        <i class="icon icon--arrow-left"></i>
      </button>
      <div class="onb-progress onb-progress--dark" data-id="progress"></div>
    </div>
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Letzter Schritt' ) %></p>
    <!-- One key, wholly emphasised: German puts the verb last and English puts
         it first, so a noun/verb pair cannot be re-ordered by a translator. -->
    <h1 class="onb__head-title"><em><%= _lcs( 'Konto erstellen' ) %></em></h1>
    <p class="onb__head-sub"><%= _lcs( 'Nur das Nötigste — in unter einer Minute fertig.' ) %></p>
  </header>

  <form class="onb__scroll onb__form" id="signup-form" autocomplete="on" novalidate>

    <div class="field">
      <label class="field__label" for="su-firstname"><%= _lcs( 'Vorname' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--user"></i></span>
        <input class="field__input" id="su-firstname" name="firstname" type="text"
               autocomplete="given-name" placeholder="Lena" value="<%= form.firstname %>" />
      </div>
    </div>

    <div class="field">
      <label class="field__label" for="su-lastname"><%= _lcs( 'Nachname' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--user"></i></span>
        <input class="field__input" id="su-lastname" name="lastname" type="text"
               autocomplete="family-name" placeholder="Hofer" value="<%= form.lastname %>" />
      </div>
    </div>

    <div class="field">
      <label class="field__label" for="su-email"><%= _lcs( 'E-Mail' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--mail"></i></span>
        <input class="field__input" id="su-email" name="email" type="email" inputmode="email"
               autocomplete="email" placeholder="name@example.com" value="<%= form.email %>" required />
      </div>
    </div>

    <div class="field">
      <label class="field__label" for="su-password"><%= _lcs( 'Passwort' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--lock"></i></span>
        <input class="field__input" id="su-password" name="password" type="password"
               autocomplete="new-password" placeholder="<%= _lcs( 'Mindestens 8 Zeichen' ) %>" required />
        <button class="field__toggle" type="button" data-id="toggle-pw" aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
          <i class="icon icon--eye"></i>
        </button>
      </div>
    </div>

    <label class="switch-row">
      <input type="checkbox" name="newsletter" data-id="newsletter" <%= form.newsletter ? 'checked' : '' %> />
      <span class="switch"><span class="switch__knob"></span></span>
      <span class="switch-row__label"><%= _lcs( 'Tipps & Events aus der Region erhalten' ) %></span>
    </label>

    <label class="check-row">
      <input type="checkbox" name="agree" data-id="agree" <%= form.agree ? 'checked' : '' %> />
      <span class="check-row__box"><i class="icon icon--check"></i></span>
      <span class="check-row__label"><%= _lcs( 'Ich akzeptiere die' ) %> <strong><%= _lcs( 'AGB' ) %></strong> &amp; <strong><%= _lcs( 'Datenschutz' ) %></strong></span>
    </label>

    <p class="auth__error" data-id="signup-error" role="alert" hidden></p>
  </form>

  <footer class="onb__foot onb__foot--bordered onb__foot--form">
    <button class="btn btn--primary btn--lg btn--block" type="submit" form="signup-form" data-id="create">
      <%= _lcs( 'Konto erstellen' ) %>
    </button>
    <p class="auth__switch onb__switch">
      <%= _lcs( 'Schon registriert?' ) %> <a class="auth__link auth__link--strong" href="#" data-id="to-login"><%= _lcs( 'Anmelden' ) %></a>
    </p>
  </footer>

</main>
